// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

import type {PostImage, PostType} from 'mattermost-redux/types/posts';

import messageHtmlToComponent from 'utils/message_html_to_component';
import type {TextFormattingOptions} from 'utils/text_formatting';
import PostEditedIndicator from '../post_view/post_edited_indicator';

type Props = {

    /*
     * Whether or not to do Markdown rendering
     */
    enableFormatting?: boolean;

    /*
     * Whether or not this text is part of the RHS
     */
    isRHS?: boolean;

    /*
     * The text to be rendered
     */
    message: string;

    /*
     * Any additional text formatting options to be used
     */
    options: Partial<TextFormattingOptions>;

    /**
     * Whether or not to proxy image URLs
     */
    proxyImages?: boolean;

    /**
     * Any extra props that should be passed into the image component
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    imageProps?: object;

    /**
     * prop for passed down to image component for dimensions
     */
    imagesMetadata?: Record<string, PostImage>;

    /**
     * Whether or not to place the LinkTooltip component inside links
     */
    hasPluginTooltips?: boolean;

    /**
     * Post id prop passed down to markdown image
     */
    postId?: string;

    /**
     * When the post is edited this is the timestamp it happened at
     */
    editedAt?: number;

    channelId?: string;

    /**
     * Post id prop passed down to markdown image
     */
    postType?: PostType;

    htmlFormattedText: string;
    disableHashtags?: boolean;
};

// export default class Markdown extends React.PureComponent<Props> {
//     static defaultProps: Partial<Props> = {
//         options: {},
//         isRHS: false,
//         proxyImages: true,
//         imagesMetadata: {},
//         postId: '', // Needed to avoid proptypes console errors for cases like channel header, which doesn't have a proper value
//         editedAt: 0,
//     }
// }

const Markdown: React.VoidFunctionComponent<Props> = (props) => {
    const {
        postId = '',
        editedAt = 0,
        message,
        enableFormatting,
        htmlFormattedText,
        isRHS = false,
        imageProps,
        imagesMetadata = {},
        hasPluginTooltips,
        channelId,
        postType,
        options = {},
        disableHashtags = false,
    } = props;

    const {mentionHighlight, disableGroupHighlight, emojiOverlayPlacement} = options;

    if (message === '' || !enableFormatting) {
        return (
            <span>
                {message}
                <PostEditedIndicator
                    postId={postId}
                    editedAt={editedAt}
                />
            </span>
        );
    }

    return messageHtmlToComponent(htmlFormattedText, isRHS, {
        imageProps,
        imagesMetadata,
        hasPluginTooltips,
        postId,
        channelId,
        postType,
        mentionHighlight,
        disableGroupHighlight,
        editedAt,
        emojiOverlayPlacement,
        disableHashtags,
    });
};

export default Markdown;
